<div class="banner">
  <a
    [ngClass]="linkClass"
    [href]="banner?.url"
    target="_blank"
    [attr.aria-label]="banner?.image?.alternativeText"
  >
    <img
      class="banner__image"
      [src]="mainService.getSmallestImageUrl(banner?.image)"
      [alt]="banner?.image?.alternativeText"
    />
  </a>
</div>
